<script setup lang="ts">
const url = 'https://google.com';

const isDesktop = computed(() =>
  useNuxtApp().$viewport.isGreaterOrEquals('tablet'),
);

const wrapperRef = ref<HTMLElement>();
const wrapperLeft = ref(0);
const wrapperWidth = ref(0);

const handleClick = () => {
  navigateTo(url, {
    external: true,
    open: {
      target: '_blank',
    },
  });
};

const updateBackgroundPosition = () => {
  if (wrapperRef.value) {
    const rect = wrapperRef.value.getBoundingClientRect();
    wrapperWidth.value = rect.width;
    wrapperLeft.value = rect.x;
  }
};

// Throttle для оптимизации
const throttle = (func: (...args: unknown[]) => void, delay: number) => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  let lastExecTime = 0;

  return (...args: unknown[]) => {
    const currentTime = Date.now();

    if (currentTime - lastExecTime > delay) {
      func(...args);
      lastExecTime = currentTime;
    } else {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(
        () => {
          func(...args);
          lastExecTime = Date.now();
        },
        delay - (currentTime - lastExecTime),
      );
    }
  };
};

const throttledUpdate = throttle(updateBackgroundPosition, 16);

onMounted(() => {
  if (wrapperRef.value && isDesktop.value) {
    const rect = wrapperRef.value.getBoundingClientRect();
    wrapperWidth.value = rect.width;
    wrapperLeft.value = rect.x;
    window.addEventListener('resize', throttledUpdate);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', throttledUpdate);
});
</script>

<template>
  <div>
    <section
      ref="wrapperRef"
      class="interscrollerWrapper"
      :style="
        isDesktop
          ? {
              backgroundSize: `${wrapperWidth}px auto`,
              backgroundPosition: `${wrapperLeft}px bottom`,
            }
          : undefined
      "
      @click="handleClick"
    />
  </div>
</template>

<style scoped>
.interscrollerWrapper {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  user-select: none;
  z-index: 1;
  max-width: 100%;
  background-repeat: no-repeat;
  background-clip: content-box;
  background-position: center bottom;
  background-attachment: fixed;
}

@media screen and (min-width: 768px) {
  .interscrollerWrapper {
    width: 100%;
    height: 300px;
    background-image: url('/interscroller-desktop.png');
  }
}

/* Добавляем отзывчивость */
@media (max-width: 767px) {
  .interscrollerWrapper {
    height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url('/interscroller-mobile.png');
    cursor: default;
    background-position: center;
    background-size: 300px auto;
  }
}
</style>
